// extracted by mini-css-extract-plugin
export var bodySections = "_c2-8";
export var gray = "_c2-7";
export var green = "_c2-4";
export var iconContainer = "_c2-9";
export var iconWidgetContainer = "_c2-1";
export var phoneIcon = "_c2-2";
export var red = "_c2-5";
export var statusDot = "_c2-3";
export var widgetContainer = "_c2-0";
export var yellow = "_c2-6";